import React from "react";
import {Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import GenericStaticCard from "../../../components/Akitatek/Card/GenericStaticCard";
import Mediatheque from "./Mediatheque";

/** Page « Gestion des images » : la médiathèque en mode gestion. /images/modifier/:id ouvre directement la fiche de l'image. */
const Asset = (inject("rootStore")(observer(class Asset extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.props.rootStore.savedDatasStore.setHeader("Images", "Gestion des images", "motherboard.jpg", this.props.rootStore.imageStore)
    }

    render() {
        const id = this.props.match?.params?.id;
        return (
            <Container className="mt-2" fluid>
                <GenericStaticCard element={
                    <h4 className="mb-0">
                        <i className="fa fa-picture-o mr-2" aria-hidden="true"/>
                        Médiathèque
                    </h4>
                }>
                    <Mediatheque mode="gerer" idOuvert={id ? parseInt(id, 10) : null}/>
                </GenericStaticCard>
            </Container>
        );
    }
})));

export default Asset;
